export default "__VITE_ASSET__Dp32uYsd__"